import { render, staticRenderFns } from "./ConsultationPrint.vue?vue&type=template&id=5602a2be&scoped=true&"
import script from "./ConsultationPrint.vue?vue&type=script&lang=js&"
export * from "./ConsultationPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5602a2be",
  null
  
)

export default component.exports